import { render, staticRenderFns } from "./VipOrder.vue?vue&type=template&id=02f23aeb&scoped=true&"
import script from "./VipOrder.vue?vue&type=script&lang=js&"
export * from "./VipOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f23aeb",
  null
  
)

export default component.exports